var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"contactButton"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"rowView"},[_c('router-link',{staticClass:"pageLinkButton",attrs:{"to":"/customer/contact"}},[_c('span',[_vm._v("お問い合わせフォーム")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }